import React from 'react'
import { Link } from 'react-router-dom'

import createArchiveContainer from '@components/Archive/createArchiveContainer'
import { filterPresets } from '@modules/form/form.module'
import statuses from '@server/constants/statuses/user-statuses'

import { AdminModel } from '@modules/user/user.module'

const roleLabels = {
	superadmin: 'Super Admin',
	consultant: 'Consultant',
}

export const getTableColumns = () => ([
	{
		label: 'Payroll No.',
		sortKey: 'payrollNo',
		getValue: (doc) => doc.payrollNo ? doc.payrollNo : '-',
	},
	{
		label: 'Status',
		prop: 'status',
		sortKey: 'status',
		getValue: (doc) => doc.status.label,
	},
	{
		label: 'Role',
		prop: 'role',
		sortKey: 'role',
		getValue: (doc) => roleLabels[doc.role],
	},
	{
		label: 'Name',
		sortKey: 'name',
		getValue: function(doc) {
			return `${doc.name.first} ${doc.name.last}`;
		},
	},
	{
		label: 'Email Address',
		prop: 'email',
		sortKey: 'email',
	},
]);

export default createArchiveContainer({
	Model: AdminModel,
	title: 'Consultants',
	queryConfig: {
		defaults: {
			sortBy: 'name',
		},
		filters: filterPresets([
			['status', {
				options: [
					{ label: 'All', value: 'any' },
					...statuses.map(s => ({
						label: s.label,
						value: s.order,
					})),
				]
			}],
			'role',
			'search',
		])
	},
	tableConfig: {
		columns: getTableColumns(),
		rowLinks: (doc) => (
			<div>
				<Link className="TableRow-link" to={`/admin/${doc.id}`}>view</Link>
				<Link className="TableRow-link" to={`/admin/${doc.id}?edit=true`}>edit</Link>
			</div>
		),
	},
});




// WEBPACK FOOTER //
// ./src/scenes/Consultants/ConsultantListContainer.jsx